import { useEffect, useState } from 'react';
import {
  getStandaloneChargeActivationStatus,
  StandaloneChargeActivationStateEnum,
  StandaloneChargeActivationStatusDTO
} from '../../../services/standalone-charges';

export const useStandaloneChargeAccountStatus = (estateId: string, enabled: boolean) => {
  const [loading, setLoading] = useState(false);
  const [connected, setConnected] = useState(false);
  const [activationStatus, setActivationStatus] =
    useState<StandaloneChargeActivationStatusDTO | null>(null);
  const [refreshVersion, setRefreshVersion] = useState(0);

  useEffect(() => {
    if (!enabled || !estateId) {
      setConnected(false);
      setActivationStatus(null);
      return;
    }

    let active = true;
    setLoading(true);
    getStandaloneChargeActivationStatus(estateId)
      .then(status => {
        if (!active) return;
        setActivationStatus(status);
        const activationStatus = status?.activation?.status;
        setConnected(
          activationStatus === StandaloneChargeActivationStateEnum.active ||
            activationStatus === StandaloneChargeActivationStateEnum.pagarmeActive
        );
      })
      .catch(() => {
        if (!active) return;
        setConnected(false);
        setActivationStatus(null);
      })
      .finally(() => active && setLoading(false));

    return () => {
      active = false;
    };
  }, [enabled, estateId, refreshVersion]);

  return {
    connected,
    loading,
    activationStatus,
    refresh: () => setRefreshVersion(version => version + 1)
  };
};
